module.exports = __webpack_public_path__ + "img/edit_icon.d322aec6.svg";